import React, { useContext, useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import {
    H_CATCHMENT_MODULE,
    H_DISTRIBUTION_MODULE,
    H_HYDRO_MODULE,
    H_INSTALLATION_MODULE,
    H_PIEZO_MODULE,
    H_PLUVIO_MODULE,
    H_PRODUCTION_MODULE,
    H_QUALITO_MODULE,
    H_RESOURCE_MODULE,
} from '../../../../../account/constants/AccessRulesConstants'
import { componentHasHabilitations } from '../../../../../utils/HabilitationUtil'
import NetworkAction from 'referencial/components/network/actions/NetworkAction'
import ContributorAction from 'referencial/components/contributor/actions/ContributorAction'
import { Grid2 } from '@mui/material'
import HabilitationQualito from './habilitations/HabilitationQualito'
import HabilitationPiezo from './habilitations/HabilitationPiezo'
import HabilitationHydro from './habilitations/HabilitationHydro'
import HabilitationPluvio from './habilitations/HabilitationPluvio'
import HabilitationInstallation from './habilitations/HabilitationInstallation'
import HabilitationProduction from './habilitations/HabilitationProduction'
import HabilitationDistribution from './habilitations/HabilitationDistribution'
import HabilitationResouce from './habilitations/HabilitationResource'
import HabilitationCatchment from './habilitations/HabilitationCatchment'
import { ModuleHabsContext } from 'administration/components/modules/AdminModulesApp'

const UserAccessPanel = () => {
    const {
        networks,
        contributors,
    } = useSelector(store => ({
        networks: store.NetworkReducer.networks,
        contributors: store.ContributorReducer.contributors,
    }), shallowEqual)

    const moduleHabs = useContext(ModuleHabsContext)

    const dispatch = useDispatch()

    useEffect(() => {
        if (!networks.length) {
            dispatch(NetworkAction.fetchNetworks())
        }
        if (!contributors.length) {
            dispatch(ContributorAction.fetchContributors())
        }
    }, [])

    return (
        <Grid2 container spacing={1}>
            {componentHasHabilitations(H_QUALITO_MODULE, true, moduleHabs?.habilitationsUser) && (
                <Grid2 size={12}>
                    <HabilitationQualito />
                </Grid2>
            )}
            {componentHasHabilitations(H_PIEZO_MODULE, true, moduleHabs?.habilitationsUser) && (
                <Grid2 size={12}>
                    <HabilitationPiezo />
                </Grid2>
            )}
            {componentHasHabilitations(H_HYDRO_MODULE, true, moduleHabs?.habilitationsUser) && (
                <Grid2 size={12}>
                    <HabilitationHydro />
                </Grid2>
            )}
            {componentHasHabilitations(H_PLUVIO_MODULE, true, moduleHabs?.habilitationsUser) && (
                <Grid2 size={12}>
                    <HabilitationPluvio />
                </Grid2>
            )}
            {componentHasHabilitations(H_INSTALLATION_MODULE, true, moduleHabs?.habilitationsUser) && (
                <Grid2 size={12}>
                    <HabilitationInstallation />
                </Grid2>
            )}
            {componentHasHabilitations(H_PRODUCTION_MODULE, true, moduleHabs?.habilitationsUser) && (
                <Grid2 size={12}>
                    <HabilitationProduction />
                </Grid2>
            )}
            {componentHasHabilitations(H_DISTRIBUTION_MODULE, true, moduleHabs?.habilitationsUser) && (
                <Grid2 size={12}>
                    <HabilitationDistribution />
                </Grid2>
            )}
            {componentHasHabilitations(H_RESOURCE_MODULE, true, moduleHabs?.habilitationsUser) && (
                <Grid2 size={12}>
                    <HabilitationResouce />
                </Grid2>
            )}
            {componentHasHabilitations(H_CATCHMENT_MODULE, true, moduleHabs?.habilitationsUser) && (
                <Grid2 size={12}>
                    <HabilitationCatchment />
                </Grid2>
            )}
        </Grid2>
    )
}

export default UserAccessPanel
